import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './PeopleClient.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

export default function advancedSearch({state, toggleAdvancedSearch, handleChange, resetFilters, resetDept}){

    const [dept, setDept] = useState('');
    const removeRef = useRef(null);

    useEffect(()=>{
        console.log('department changed')
        Object.keys(state.dept).forEach(function(key) {
            if(state.department==key){
                setDept(state.dept[key]);
            }
        });
    },[state.department])

    useEffect(()=>{
        if(dept){
            removeRef.current.focus();
        }
    },[dept])

    const removeClicked = ()=>{
        setDept('');
        resetDept();
    }

    const resetFilterClicked = ()=>{
        resetFilters();
        setDept('');
    }

    return(
        <div className="advanced_search">
        <div className={state.advancedOpen==false? "search-options row hidden":"search-options row"}>
            <div className='option-wrapper'>
                <div className='dept-container'>
                    <input name="department" id="department" 
                    placeholder="Organization Unit" 
                    empty="Organizational Unit" 
                    data-field-type="short_text" 
                    type="text"
                    onChange={handleChange} 
                    value={state.department} 
                    list="org_list"/>
                    {dept? 
                        <div className='departmentBtn'>{dept}
                            <a className='remove' onClick={removeClicked} ref={removeRef} tabindex="0">x
                            </a> 
                        </div>:""}
                    
                    <datalist id="org_list">
                        {Object.entries(state.dept).map((de)=>(
                            <option data-value={de[0]} value={de[1]}>{de[1]}</option>
                        ))}
                    </datalist>   
                </div>                                                    
            <input name="ucid" id="ucid" 
                placeholder="UCID" 
                empty="UCID" 
                data-field-type="short_text" 
                type="text" 					
                onChange={handleChange} 
                value={state.ucid}/>                                                                
            <input name="location" id="location" 
                placeholder="Location" 
                empty="Location" 
                data-field-type="short_text" 
                type="text" 					
                onChange={handleChange} 
                value={state.location}/>                                                                  
            <input name="phone" 
                id="phone" 
                placeholder="Official Phone" 
                empty="Official Phone" 
                data-field-type="short_text" 
                type="text"
                onChange={handleChange} 
                value={state.phone}/>
            </div>
        </div>
        <div className="header">
            <div>
            <FontAwesomeIcon icon={state.advancedOpen==false? faChevronDown:faChevronUp} style={{color:"white"}}/>
            {/* <a onClick={toggleAdvancedSearch}> {state.advancedOpen==false? "More Filters":"Fewer Filters"}</a> */}
            <a onClick={toggleAdvancedSearch}> Additional Filters</a>
            </div>
            <div className="submit">
                <a onClick={resetFilterClicked}>Reset Filters</a>
                <button type="submit" class="btn btn-danger" >SEARCH</button>
            </div>
        </div>
    </div>
    )
}


// WEBPACK FOOTER //
// ./src/PeopleClient/advancedSearch.js